// extracted by mini-css-extract-plugin
module.exports = {"SortingSidebar__head":"SortingSidebar__head","SortingSidebar__options":"SortingSidebar__options","SortingSidebar__option":"SortingSidebar__option","isActive":"isActive"};